import { render } from "./product-quick-view.vue?vue&type=template&id=3e98ba22"
import script from "./product-quick-view.vue?vue&type=script&lang=js"
export * from "./product-quick-view.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__